export enum CustomFieldsEnum {
    TWS_PRODUCT_CATALOG_FAMILY = 'tws-product-catalog-family',
    TWS_TWS_OPTIONS = 'tws-tws-options',
    TWS_MATCHING_TAP_WATER_SYSTEM = 'tws-matching-tap-water-system',
    TWS_MATCHING_UNIT = 'tws-matching-unit',
    TWS_INPUT_METHOD = 'tws-input-method',
    TWS_INSTALLATION_TYPE = 'tws-installation-type',
    CHECKBOX_RADIO_SELECT = 'checkbox-radio-select',
    NUMBER = 'number',
    TEXT = 'text',
    SELECT = 'select',
    MULTISELECT_WITH_QUANTITY = 'multiselectWithQuantity',
    MULTISELECT = 'multiselect',
    RADIO_SELECT = 'radio-select',
    CHECKBOX = 'checkbox',
    TWS_MATCHING_TANK_QUANTITY = 'tws-matching-tank-quantity',
    TWS_TANK_SELECTION_RESULT = "tws-tank-selection-result"
}